import React from 'react'
import { RosterImportStatus } from '../../services/RosterService'
import RosterImportProgress from './RosterImportProgress'
import OptionsModal from '../molecules/OptionsModal'
import WarningIcon from '../atoms/Icons/WarningIcon.svg'

interface RosterImportModalProps {
  visible: boolean
  rosterHash: string
  fileName: string
  onComplete: (status: RosterImportStatus) => void
  onClose: () => void
}

/**
 * Modal component for roster import with real-time progress tracking
 */
const RosterImportModal: React.FC<RosterImportModalProps> = ({
  visible,
  rosterHash,
  fileName,
  onComplete,
  onClose,
}) => {
  const [error, setError] = React.useState<Error | null>(null)
  const [isComplete, setIsComplete] = React.useState(false)

  const handleComplete = (status: RosterImportStatus) => {
    setIsComplete(true)
    onComplete(status)
  }

  const handleError = (error: Error) => {
    setError(error)
  }

  if (!visible) {
    return null
  }

  if (error) {
    return (
      <OptionsModal
        visible={true}
        message={<p className="modal-title">Error importing roster: {error.message}</p>}
        firstButtonText="Close"
        firstButtonType="info"
        secondButtonText="Dismiss"
        secondButtonType="clear"
        onFirstButtonClick={onClose}
        onSecondButtonClick={onClose}
        onClose={onClose}
        icon={<WarningIcon />}
      />
    )
  }

  if (isComplete) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '40px',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <RosterImportProgress
          rosterHash={rosterHash}
          fileName={fileName}
          onComplete={handleComplete}
          onError={handleError}
        />
      </div>
    </div>
  )
}

export default RosterImportModal
